import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from '../contexts/auth'

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth()
  const location = useLocation()

  if (!user) {
    return <Navigate to='/' replace state={{ from: location }} />
  }

  return children
}

export default ProtectedRoute
